exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my .my__content[data-v-3f327a8e] {\n  min-height: calc(100vh - 2.9rem);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}", ""]);

// exports
